/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(function () {
  $(".facts-accordion").each(function () {
    const section = $(this);
    const sectionEl = this;
    let inView = false;
    let activeIndex = 0;

    // Attach the real source (stored in data-src) only on demand.
    // Until this runs, preload="none" + no src means zero network usage.
    function hydrateVideo(video) {
      if (!video || video.dataset.faHydrated) return;
      const sources = video.querySelectorAll("source[data-src]");
      if (!sources.length) return;
      video.dataset.faHydrated = "1";
      $(sources).each(function () {
        this.src = this.getAttribute("data-src");
      });

      // Fallback loop: the native `loop` attribute is unreliable for lazily-loaded,
      // muted inline videos on iOS Safari / some Android Chrome — they fire `ended`
      // and freeze on the last frame instead of restarting. When `loop` works this
      // never fires, so it's a no-op in the healthy case.
      video.addEventListener("ended", function () {
        try {
          video.currentTime = 0;
        } catch (e) {}
        const p = video.play();
        if (p !== undefined) p.catch(function () {});
      });

      video.load();
    }

    function pauseAllVideos() {
      section.find(".facts-accordion__right-slide video").each(function () {
        this.pause();
        this.currentTime = 0;
      });
      section.find(".facts-accordion__media-mobile video").each(function () {
        this.pause();
        this.currentTime = 0;
      });
    }

    function playActiveVideos(index) {
      // Don't load or play anything until the section is on screen.
      if (!inView) return;

      const desktopVideo = section
        .find(".facts-accordion__right-slide")
        .eq(index)
        .find("video")[0];
      if (desktopVideo) {
        hydrateVideo(desktopVideo);
        const playPromise = desktopVideo.play();
        if (playPromise !== undefined) playPromise.catch(function () {});
      }

      const mobileVideo = section
        .find(".facts-accordion__item")
        .eq(index)
        .find(".facts-accordion__media-mobile video")[0];
      if (mobileVideo) {
        hydrateVideo(mobileVideo);
        const playPromise = mobileVideo.play();
        if (playPromise !== undefined) playPromise.catch(function () {});
      }
    }

    function setActive(index) {
      const items = section.find(".facts-accordion__item");
      const total = items.length;
      if (index < 0 || index >= total) return;

      activeIndex = index;
      pauseAllVideos();

      items.removeClass("active");
      section.find(".facts-accordion__right-slide").removeClass("active");

      items.eq(index).addClass("active");
      section
        .find(".facts-accordion__right-slide")
        .eq(index)
        .addClass("active");

      playActiveVideos(index);

      section
        .find(".facts-accordion__prev")
        .toggleClass("disabled", index === 0);
      section
        .find(".facts-accordion__next")
        .toggleClass("disabled", index === total - 1);
    }

    section.on("click", ".facts-accordion__item", function () {
      const index = section.find(".facts-accordion__item").index(this);
      if ($(this).hasClass("active")) return;
      setActive(index);
    });

    section.on("click", ".facts-accordion__prev:not(.disabled)", function () {
      const current = section
        .find(".facts-accordion__item")
        .index(section.find(".facts-accordion__item.active"));
      setActive(current - 1);
    });

    section.on("click", ".facts-accordion__next:not(.disabled)", function () {
      const current = section
        .find(".facts-accordion__item")
        .index(section.find(".facts-accordion__item.active"));
      setActive(current + 1);
    });

    setActive(0);

    // Only start (and load) the active video once the section scrolls into view;
    // pause everything when it leaves.
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              inView = true;
              playActiveVideos(activeIndex);
            } else {
              inView = false;
              pauseAllVideos();
            }
          });
        },
        { root: null, rootMargin: "200px", threshold: 0.1 }
      );
      io.observe(sectionEl);
    } else {
      inView = true;
      playActiveVideos(activeIndex);
    }
  });

  if (window.innerWidth > 799) {
    var sr = ScrollReveal();

    sr.reveal('.facts-accordion__intro', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true
    });

    sr.reveal('.facts-accordion__main', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true
    });
  }
});